module.exports = __webpack_public_path__ + "static/media/icon-sms.5bb472a9.svg";